export const DEFAULT_ERROR_MESSAGE =
  'Something went wrong while doing that. Please contact Admin support or try again later.';

export const GET_DATA_ERROR = 'Something went wrong while fetching your data';

export const PLAN_LIMIT_ERROR =
  'You have reached your plan limit. Please upgrade your plan.';
